import React from 'react'
import { QRCode } from 'react-qrcode-logo'
import PropTypes from 'prop-types'
import Bridge from '../../utils/bridge'
import HangSengIcon from '../../assets/images/payment/hase.png'

const QrCode = ({ qrCodeString }) => {
  const downloadQrCode = () => {
    const canvas = document.getElementById('fps-qr-code')
    const dataUrl = canvas.toDataURL('image/png')
    Bridge.send({
      type: 'QR_CODE_SAVE',
      data: {
        dataUrl,
      },
    })
  }

  return <div onClick={downloadQrCode}><QRCode id="fps-qr-code" value={qrCodeString} size={192} logoImage={HangSengIcon} logoWidth={90} logoHeight={30}/></div>
}

QrCode.propTypes = {
  qrCodeString: PropTypes.string.isRequired,
}

export default QrCode
